import {DefaultEventsMap, DeviceType} from '@gongxigames/framework/core';
import {IWinMeter, WinMeterView, WinMeterViewMobileLandscape, WinMeterViewMobilePortrait} from '@gongxigames/framework/slot/modules/winmeter/index';
import {ScreenOrientedView} from '@gongxigames/framework/slot/fragments/module/view';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';

export class WinMeterViewMobile extends ScreenOrientedView<DefaultEventsMap, WinMeterView> implements IWinMeter {
    public static readonly NAME: symbol = Symbol('WinMeterViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected landscapeViewName: symbol = WinMeterViewMobileLandscape.NAME;
    protected portraitViewName: symbol = WinMeterViewMobilePortrait.NAME;

    public hideWinMeter(): void {
        this._views.forEach((view: WinMeterView) => {
            view.hideWinMeter();
        });
    }

    public setValue(value: number, setIfPlaying: boolean): void {
        this._views.forEach((view: WinMeterView) => {
            view.setValue(value, setIfPlaying);
        });
    }

    public countUp(from: number, to: number, duration: number, callback: Function): void {
        this._views.forEach((view: WinMeterView) => {
            view.countUp(from, to, duration, callback);
        });
    }

    public stopAfterShowingFinalValue(value: number, clearMeterAfterPause: boolean): void {
        this._views.forEach((view: WinMeterView) => {
            view.stopAfterShowingFinalValue(value, clearMeterAfterPause);
        });
    }

    public stopFinalValueTimer(): void {
        this._views.forEach((view: WinMeterView) => {
            view.stopFinalValueTimer();
        });
    }

    public snapToFinalValue(): void {
        this._views.forEach((view: WinMeterView) => {
            view.snapToFinalValue();
        });
    }

    public setValueIfPlaying(value: number): void {
        this._views.forEach((view: WinMeterView) => {
            view.setValueIfPlaying(value);
        });
    }
}
